import * as yup from 'yup'

export const ScraperJobConfigurationUpdateSchema = yup.object({
  applyToTms: yup.boolean(),
  clientMutationId: yup.string().nullable(),
  comment: yup.string().nullable(),
  demoMode: yup.boolean().nullable(),
  enabled: yup.boolean().nullable(),
  waitTime: yup.number().integer().nullable(),
  jobQueueName: yup.string().nullable(),
})

export type TScraperJobConfigurationUpdateSchema = yup.InferType<
  typeof ScraperJobConfigurationUpdateSchema
>
